import { render, staticRenderFns } from "./FormInputPermissionOtherUserGroup.vue?vue&type=template&id=2c4bcf3a&scoped=true&lang=pug"
import script from "./FormInputPermissionOtherUserGroup.vue?vue&type=script&lang=ts"
export * from "./FormInputPermissionOtherUserGroup.vue?vue&type=script&lang=ts"
import style0 from "./FormInputPermissionOtherUserGroup.vue?vue&type=style&index=0&id=2c4bcf3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bcf3a",
  null
  
)

export default component.exports